import {
    default_CardRegular,
    default_CardDefault,
    featured_withCards_noLimit,
    defaultSideScroll_CardRegular,
    featured_verticalRightCol_noLimit,
    featured_description,
    default_CardShow,
    description,
} from "../gridLayouts/FLP_gridLayouts";
import {
    DEFAULT_KEY,
    DEFAULT_CONDENSED_KEY,
    FEATURED_KEY,
    DEFAULT_LIGHT_KEY,
    DEFAULT_DARK_KEY,
    OLYMPICS_DARK_KEY,
    OLYMPICS_LIGHT_KEY,
    FEATURED_VERTICALRIGHTCOL_KEY,
    FEATURED_DESCRIPTION,
    DEFAULT_SHOWS_KEY,
    DESCRIPTION,
} from "../../../pages/FlexibleLandingPage/constants";

const KeyToLayoutMap = new Map([
    [DEFAULT_KEY, default_CardRegular],
    [DEFAULT_LIGHT_KEY, default_CardRegular],
    [DEFAULT_DARK_KEY, default_CardRegular],
    [DEFAULT_CONDENSED_KEY, default_CardDefault],
    [FEATURED_KEY, featured_withCards_noLimit],
    [OLYMPICS_DARK_KEY, defaultSideScroll_CardRegular],
    [OLYMPICS_LIGHT_KEY, defaultSideScroll_CardRegular],
    [FEATURED_VERTICALRIGHTCOL_KEY, featured_verticalRightCol_noLimit],
    [FEATURED_DESCRIPTION, featured_description],
    [DEFAULT_SHOWS_KEY, default_CardShow],
    [DESCRIPTION, description],
]);

/**
 * This function maps the layout key from a lineup the to an ContentGrid layout
 *
 * @param {string} key the layout key
 * @returns {Object} the matching ContentGrid layout
 */
export const getLayout = (key) => {
    // Has a fall back value to default_CardRegular if it cannot find the layout
    const layout = KeyToLayoutMap.get(key) ?? default_CardRegular;
    return layout;
};
